var render, staticRenderFns
import script from "./DoughnatChart.vue?vue&type=script&lang=js&"
export * from "./DoughnatChart.vue?vue&type=script&lang=js&"
import style0 from "./DoughnatChart.vue?vue&type=style&index=0&id=b4ae1a74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ae1a74",
  null
  
)

export default component.exports